var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0117 15H1.51172M30.7617 1.5V8.25M12.7617 1.5V8.25M12.3117 46.5H31.2117C34.9921 46.5 36.8822 46.5 38.3262 45.7643C39.5962 45.1171 40.6289 44.0845 41.276 42.8144C42.0117 41.3705 42.0117 39.4804 42.0117 35.7V16.8C42.0117 13.0196 42.0117 11.1295 41.276 9.68556C40.6289 8.41547 39.5962 7.38285 38.3262 6.73571C36.8822 6 34.9921 6 31.2117 6H12.3117C8.53136 6 6.64119 6 5.19728 6.73571C3.92719 7.38285 2.89457 8.41547 2.24742 9.68556C1.51172 11.1295 1.51172 13.0196 1.51172 16.8V35.7C1.51172 39.4804 1.51172 41.3705 2.24742 42.8144C2.89457 44.0845 3.92719 45.1171 5.19728 45.7643C6.64119 46.5 8.53136 46.5 12.3117 46.5ZM21.7556 24.7438C19.9561 22.6986 16.9555 22.1484 14.7009 24.0213C12.4464 25.8941 12.129 29.0254 13.8995 31.2404C15.185 32.8485 18.7451 36.0143 20.5992 37.6281C21.0012 37.9779 21.2021 38.1529 21.4376 38.2222C21.6417 38.2823 21.8695 38.2823 22.0735 38.2222C22.309 38.1529 22.5099 37.9779 22.9119 37.6281C24.766 36.0143 28.3261 32.8485 29.6116 31.2404C31.3821 29.0254 31.1035 25.8744 28.8102 24.0213C26.5169 22.1681 23.555 22.6986 21.7556 24.7438Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointments);
export default __webpack_public_path__ + "static/media/Appointments.0c5f7879381d648eeff1a7aca8c56747.svg";
export { ForwardRef as ReactComponent };